import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpDelayedContent
     * @memberof app
     *
     * @restrict E
     *
     * @description
     * Wrap any HTML with this directive and show it delayed or only for a specific amount of time.
     *
     * @param {*} onChange This value will be listened for changes. When it changes, the content will be displayed with
     *  the specified delay for the specified duration.
     * @param {Number} delay Time to wait before the content will be displayed in milliseconds.
     * @param {Number} duration Number of milliseconds the content will be displayed.
     *
     * @example
     <pkp-delayed-content on-change="bid.minQuantity" ng-show="bidForm.minQuantity.$valid" class="help-block">
         <small>
             <i class="fa fa-info-circle" aria-hidden="true"></i> The volume-based regulated tariff has been updated.
         </small>
     </pkp-delayed-content>
     *
     * @author flzemke.btc
     */
    angular.module('app').directive('pkpDelayedContent', pkpDelayedContent);

    function pkpDelayedContent($timeout) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            scope: {
                onChange: '=',
                delay: '@',
                duration: '@'
            },
            template: '<ng-transclude></ng-transclude>',
            link: linkFn
        };

        function linkFn(scope, elem) {
            angular.element(elem).addClass('hidden');

            scope.delay = angular.isUndefined(scope.delay) ? 1000 : scope.delay;
            scope.duration = angular.isUndefined(scope.duration)
                ? 2000
                : scope.duration;

            scope.$watch(
                function () {
                    return scope.onChange;
                },
                function (newModel, oldModel) {
                    if (!newModel || angular.equals(oldModel, newModel)) {
                        return;
                    }

                    $timeout(function () {
                        angular.element(elem).removeClass('hidden');

                        $timeout(function () {
                            angular.element(elem).addClass('hidden');
                        }, scope.duration);
                    }, scope.delay);
                },
                true
            );
        }
    }
})();
